// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from "react";

export const Maximize = ({ size, stroke, fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill={fill}
      stroke={stroke}
      strokeWidth="2px"
    >
      <polyline points="43.38 4.62 43.16 4.83 31.5 16.5" />
      <polygon points="43.82 8.87 43.01 8.83 43.16 4.84 39.16 4.98 39.13 4.17 44 4 43.82 8.87" />
      <polyline points="16.5 16.5 4.84 4.83 4.62 4.62" />
      <polygon points="4 4 8.87 4.17 8.84 4.98 4.84 4.84 4.99 8.83 4.18 8.87 4 4" />
      <polyline points="31.5 31.5 43.16 43.17 43.38 43.38" />
      <polygon points="44 44 39.13 43.83 39.16 43.02 43.16 43.16 43.01 39.17 43.82 39.13 44 44" />
      <polyline points="4.62 43.38 4.84 43.17 16.5 31.5" />
      <polygon points="4.18 39.13 4.99 39.17 4.84 43.16 8.84 43.02 8.87 43.83 4 44 4.18 39.13" />
    </svg>
  );
};
